import React from 'react'
import Img from 'gatsby-image'
import MediaQuery from 'react-responsive'

// Import common components
import { FlexBox } from '../../common/Box'
import GameDetail from '../../common/GameDetail'
import GameItem from './GameItem'

// Import constant
import { DATA } from '../../../constants/data'

const Games = ({ data, id }) => {
  const limitData = data.slice(0, DATA.MAX_GAMES)

  return (
    <MediaQuery maxWidth={767}>
      {(matches) => {
        return (
          <FlexBox
            flexWrap='wrap'
            id={id}
          >
            {
              limitData.map((item, index) => {
                return (
                  <GameItem key={index} dataLength={limitData.length}>
                    <Img sizes={item.node.banner.sizes} />
                    <GameDetail
                      matches={matches}
                      title={item.node.title}
                      description={item.node.description}
                      href={item.node.slug}
                      genre={item.node.genre}
                      author={item.node.tags.join(' ')}
                    />
                  </GameItem>
                )
              })
            }
          </FlexBox>
        )
      }}
    </MediaQuery>
  )
}

export default Games



// WEBPACK FOOTER //
// ./src/components/sections/games/Games.js